import loadable from '@hh.ru/loadable-component';

export default loadable(() => import('./ApplicantPortrait.route'));
